import styled from 'styled-components';

const BoxItem = styled.div`
  width: calc(50% - 20px );
  /* height: 700px; */
  background: #FFFFFF;
  box-shadow: 6px 6px 19px -3px rgba(13, 64, 152, 0.16);
  border-radius: 13px;
  margin: 50px 0;
  transition: all .5s;
  &:hover {
    box-shadow: 6px 6px 19px -3px rgba(29, 38, 54, 0.25);
  }
  @media (max-width: 768px) {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

const BoxItemEmpty = styled(BoxItem)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
  font-size: 34px;
  @media (max-width: 768px) {
    display: none;
  }
`;

export {
  BoxItem,
  BoxItemEmpty
}